<template>
    <b-media no-body class="p-2">
        <b-media-aside vertical-align="center">
            <UserPicture :user="keyResult.user" />
        </b-media-aside>
        <b-container tag="b-media-body" class="p-0" fluid>
            <b-row no-gutters align-v="center">
                <b-col lg="12" xl="6">
                    <b-row no-gutters>
                        <b-col>
                            <b-link
                                :href="goToKeyResultPage(keyResult.objective_id, keyResult.id)"
                                :class="{ 'font-weight-bold': boldTitle }"
                            >
                                {{ keyResult.title }}
                            </b-link>
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col>
                            <TextLineContainer>
                                <RenderSimpleHtmlText>
                                    {{ $t('responsible', { name: keyResult.user.name }) }}
                                </RenderSimpleHtmlText>
                            </TextLineContainer>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="12" xl="6" class="mt-2 mt-xl-0">
                    <b-row no-gutters>
                        <b-col>
                            <ProgressBar
                                :value="calculateKeyResultProgress(keyResult.progress)"
                                height="1rem"
                                use-default-label
                            />
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col>
                            <ActionsContainer>
                                <LastCheckinDateFromNow slot="last-checkin" :last-checkin="keyResult.last_checkin" />
                                <CheckInBtn
                                    slot="checkin-btn"
                                    id="btn-strategy-new-checkin"
                                    @click="onClickCheckIn(keyResult.objective_id, keyResult.id)"
                                />
                                <Dropdown
                                    slot="dropdown"
                                    :on-edit-callback="onEdit(keyResult.objective_id, keyResult.id)"
                                    :on-delete-callback="onDelete(keyResult.objective_id, keyResult.id)"
                                />
                            </ActionsContainer>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </b-media>
</template>

<script>
import ProgressBar from '@/views/components/progress-bar/ProgressBar.vue'
import { ActionsContainer, LastCheckinDateFromNow } from './components'
import { UserPicture, RenderSimpleHtmlText, Dropdown, TextLineContainer, CheckInBtn } from '../../components'
import { deleteKeyResultFromAPI } from './api'
import { getV1PathWithOrigin } from '@/router/routesToV1'
import { danger, success } from '@/lib/notification'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import commonMessages from '../../common-messages'

export default {
    name: 'KeyResultDetails',
    components: {
        CheckInBtn,
        ProgressBar,
        ActionsContainer,
        LastCheckinDateFromNow,
        UserPicture,
        RenderSimpleHtmlText,
        Dropdown,
        TextLineContainer,
    },
    props: {
        keyResult: {
            type: Object,
            required: true,
        },
        boldTitle: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        onClickCheckIn(objectiveId, keyResultId) {
            this.$router.push({
                path: `${this.$route.path}/objectiveId/${objectiveId}/resultId/${keyResultId}/checkin`,
            })
        },
        goToKeyResultPage(objectiveId, keyResultId) {
            return `${getV1PathWithOrigin('/okr/objectives/key-results', {
                objectiveId: objectiveId,
                keyResultId: keyResultId,
            })}`
        },
        onEdit(objectiveId, keyResultId) {
            return () => {
                this.$router.push({
                    path: `${this.$route.path}/objectiveId/${objectiveId}/resultId/${keyResultId}/edit`,
                })
            }
        },
        onDelete(objectiveId, keyResultId) {
            return () => {
                proceedWithConfirmation({
                    type: 'warning',
                    icon: 'warning',
                    message: this.$t('deletionAlert.message'),
                    confirmButtonText: this.$t('deletionAlert.textButtonConfirmation'),
                    onConfirm: () => {
                        return deleteKeyResultFromAPI(objectiveId, keyResultId)
                    },
                    callback: () => {
                        success(this.$t('deletionAlert.onSuccess'))
                        this.onDeletedKeyResult()
                    },
                    onError: () => {
                        danger(this.$t('deletionAlert.onError'))
                    },
                })
            }
        },
        onDeletedKeyResult() {
            this.$emit('onDeletedKeyResult')
        },
        calculateKeyResultProgress(progress) {
            return progress * 100
        },
    },
    i18n: {
        messages: {
            'en-US': {
                deletionAlert: {
                    message: 'You will no longer be able to retrieve this key result.',
                    textButtonConfirmation: 'Yes, delete',
                    onSuccess: 'Key result deleted successfully.',
                    onError: 'Ops... Something went wrong while deleting the key result.',
                },
            },
            'en-ES': {
                deletionAlert: {
                    message: 'Ya no podrá recuperar este resultado clave.',
                    textButtonConfirmation: 'Si, eliminar',
                    onSuccess: 'El resultado clave se eliminó con éxito.',
                    onError: 'Vaya, algo salió mal al eliminar el resultado clave.',
                },
            },
            'pt-BR': {
                deletionAlert: {
                    message: 'Você não poderá mais recuperar este resultado chave.',
                    textButtonConfirmation: 'Sim, excluir',
                    onSuccess: 'Resultado chave excluído com sucesso.',
                    onError: 'Ops, algo deu errado ao excluir o resultado chave.',
                },
            },
        },
        sharedMessages: commonMessages,
    },
}
</script>
